import React from 'react';
import { fadeIn } from '../variants';
import { motion } from 'framer-motion';
import cv from '../assets/Cv.pdf'



const About = () => {
  
  return (<section id='about' className='section'>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center lg:flex-row lg:justify-center gap-x-10'>
          {/* image */}
          <motion.div variants={fadeIn('left',0.4)} 
              initial='hidden' whileInView={"show"} 
              viewport={{once:false,amount:0.7}} 
               className='image-ilyas mb-2'></motion.div>
          {/* text */}
          <div className='flex flex-col items-center'>
            <div className='flex flex-col lg:flex-row lg:gap-x-5'>
              <motion.div variants={fadeIn('left',0.5)} 
              initial='hidden' whileInView={"show"} 
              viewport={{once:false,amount:0.7}}  className='flex flex-col items-center'>
                <h2 className='text-3xl'>About Me</h2>
                <h2 className='font-semibold mb-2 max-w-lg mx-auto lg:mx-0  font-secondary text-2xl'>I'm Ilyas Dahhou<span className='text-accent'>, a Software engineering student</span></h2>
                <p className='max-w-lg mx-auto lg:mx-0 mb-2 '>
                  At the National Institute of Posts and Telecommunications (INPT) in Rabat. I am persevering, dynamic, and motivated with a strong spirit of analysis and synthesis. I am passionate about web development, technology, and science.
                </p>
              </motion.div>
               <motion.div variants={fadeIn('right',0.6)} 
              initial='hidden' whileInView={"show"} 
              viewport={{once:false,amount:0.7}}  className="about__skills grid">
                    <div className="skills__data">
                        <div className="skills__titles">
                            <h3 className="skills__name">Frontend Development</h3>
                            <span className="skills__number lg:ml-4">60%</span>
                        </div>
                        <div className="skills__bar">
                            <span className="skills__percentage development"></span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <div className="skills__titles">
                            <h3 className="skills__name">Backend Development</h3>
                            <span className="skills__number">80%</span>
                        </div>
                        <div className="skills__bar">
                            <span className="skills__percentage Backend"></span>
                        </div>
                    </div>
                </motion.div> 
            </div>
            <motion.a variants={fadeIn('down',0.7)} 
              initial='hidden' whileInView={"show"} 
              viewport={{once:false,amount:0.7}}  href={cv} download="Cv-Dahhou-Ilyas" className='btn btn-sm cv mt-2'>Download CV</motion.a>
          </div>
        </div>
      </div>
    </section>);
};

export default About;
